import React from "react";

const features = [
  "78-page Complete Institutional Implementation Framework (PDF)",
  "4-Tier Vulnerability Scoring Model — complete with risk and resilience factor tables",
  "12 Documented Borrower Scoring Case Studies — all four tiers",
  "16 Compliance-Ready Email Templates — CFPB language integrated",
  "24 SMS Outreach Templates — all risk tiers",
  "6 Word-for-Word Specialist Phone Scripts",
  "20 Objection Response Frameworks",
  "90-Day Deployment Timeline — daily task assignments",
  "CFPB Regulation X Reference Framework",
  "Fair Lending Governance Checklist",
  "3 Dashboard Templates — Executive, Manager, Analyst views",
  "52-Week KPI Tracking and business-case measurement model",
  "Executive Presentation — internal stakeholder briefing",
  "Complete institutional ZIP deployment package",
];

const compliance = [
  "Runs alongside existing servicing systems", "Institution-controlled data", "Governance review resources included",
  "Zero external vendor access", "Regulation X reference materials", "No data sharing agreements",
];

const Purchase = () => {
  return (
    <section id="purchase" className="section pur-bg">
      <div className="w">
        <div className="pur-center">
          <div className="pur-card">
            <div className="pc-top">
              <div className="pc-label">Institutional License</div>
              <div className="pc-price">$4,995</div>
              <div className="pc-per"><strong>One Purchase · One Portfolio · One Secure Download</strong></div>
            </div>
            <div className="pc-body">
              <div className="pc-feats">
                {features.map((f) => (<div className="pc-f" key={f}>{f}</div>))}
              </div>

              <div className="dual-track">
                <div className="checkout-shell">
                  <a
                    href="https://buy.stripe.com/7sYfZg7iE2fienH6aS8N202"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary btn-gold"
                    data-testid="checkout-button"
                    style={{ display: "inline-flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: 420, height: 52, fontSize: "1rem", boxSizing: "border-box" }}
                  >
                    Acquire License — Secure Checkout
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  </a>
                </div>

                <div style={{ fontSize: "0.72rem", color: "var(--g3)", textAlign: "center", marginTop: "0.8rem" }}>
                  Secure payment by Stripe · Cards, Apple Pay &amp; Google Pay · International currencies accepted · One purchase = one download
                </div>

                <div className="track-divider" style={{ marginTop: "1.5rem" }}>— or access via corporate procurement track —</div>

                <a href="mailto:hello@mortgagesurvivalplaybook.com?subject=Institutional%20Procurement%20Request%20—%20W-9%20%26%20Invoice%20—%20Mortgage%20Survival%20Playbook%202026" className="btn-invoice">
                  ✉ &nbsp;Request Invoice &amp; W-9
                </a>
                <a href="mailto:hello@mortgagesurvivalplaybook.com?subject=Enterprise%20Pricing%20Request%20—%20Mortgage%20Survival%20Playbook%202026" className="btn-invoice">
                  Request Enterprise Pricing
                </a>

                <div className="invoice-note">Supports standard corporate accounting channels: formal invoice with Net 15 terms, W-9 documentation, Master Service Agreement coordination, and institutional ACH or Federal Wire routing.</div>
              </div>
            </div>
            <div className="pc-foot">
              <p><strong>90-Day Implementation Support</strong> — email any deployment question within 90 days and we respond personally.<br />Enterprise multi-portfolio deployment: <a href="mailto:hello@mortgagesurvivalplaybook.com">hello@mortgagesurvivalplaybook.com</a></p>
            </div>
          </div>

          <div className="compliance-features">
            {compliance.map((c) => (<span className="cf" key={c}>{c}</span>))}
          </div>

          <div className="close-quote">
            <p>Earlier identification. Appropriate, approved intervention. A preserved servicing relationship when possible. <strong>A documented process and a measured outcome.</strong></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Purchase;
